<template>
<el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick" class="inside_tab">
    <el-tab-pane label="沟通记录" name="first">
        <div class="meeting-right-chatroom">
            <!-- <div v-if="comdata.mediatorself&&!Boolean(caseStatus)" class="caseStatusBtn" @click="openStatus"><i class="status"></i>调解状态</div> -->
            <div v-if="comdata.mediatorself" :class="[{on:iflylatStatus},'voiceBtn']" @click="speechSwitch"><i :class="[{on:iflylatStatus},'status']"></i>{{iflylatStatus?'语音识别中':'开启语音识别'}}</div>
            <div :class="[{botcss:comdata.mediatorself},'meeting-chatroom-list']" ref="messageListBox" id="messageBox">
                <ul>
                    <li v-for="msg in msgs" :key="msg.index" :class="{'meeting-chatroom-self': msg.id==comdata.userID}">
                        <span><b :class="msg.who=='【系统提示】'?'whoClass':''">{{ msg.who }} </b> {{msg.time}}
                            <i v-if="msg.type == 'HANDLER_INPUT'" class="text inputicon">手动输入</i>
                            <i v-else-if="msg.type == 'VOICE_DISCERN'" class="voice inputicon">语音识别</i>
                        </span>
                        <div>{{msg.content}}</div>
                    </li>
                </ul>
            </div>
            <div class="meeting-chatroom-speaking">
                <textarea v-model="inputMessage" @keyup.enter="onSendMessageClick" class="input-textarea" placeholder="在此输入消息，按回车键发送"></textarea>
                <div class="meeting-btn-send">
                    <!-- <i class="expression-icon"></i> -->
                    <button @click="onSendMessageClick">发送</button>
                </div>
            </div>
        </div>
    </el-tab-pane>
    <el-tab-pane label="案件材料" name="second">
        <caseinfo :insideInfoCaseId="caseinfoCaseId" :singleMeetingId="singleMeetingId" ref="comCaseinfo" :curCaseDetail="detailcaseinfo" :documentsList="documentsList" :comdata="comdata" :wselement="wselement"></caseinfo>
    </el-tab-pane>
    <el-tab-pane name="third">
        <span slot="label" class="eltablabel"><i v-if="workbenchstatus" class="curNewMessage"></i>工作区</span>
        <div class="wodk_menu">
            <div v-if="createdFlag ||(recordFlag && attendFlag)">
                <template v-if="comdata.roleType == 'MEDIATOR'">
                    <div v-if="createdFlag" class="wodk_item" @click="dialogRecord"><i class="el-collapse-item__arrow el-icon-arrow-right"></i>笔录</div>
                    <div v-if="attendFlag" class="wodk_item" @click="openDocumentSign"><i class="el-collapse-item__arrow el-icon-arrow-right"></i>笔录</div>
                    <div class="wodk_item" @click="dialogMedBook"><i class="el-collapse-item__arrow el-icon-arrow-right"></i>仲裁调解书</div>
                    <div class="wodk_item" @click="dialogEnv"><i class="el-collapse-item__arrow el-icon-arrow-right"></i>送达回证</div>
                    <div v-if="createdFlag" style="text-align: center;">
                        <el-button @click="dialogRecord" type="primary">发送笔录</el-button>
                    </div>
                    <div v-if="attendFlag" style="text-align: center;">
                        <el-button @click="openDocumentSign" type="primary">笔录签署</el-button>
                    </div>
                </template>
            </div>
            <template v-if="!comdata.iswatcher && comdata.roleType !== 'MEDIATOR'">
                <!-- <div class="wodk_item" v-if="viewrecord" @click="openRecord('MEDIATION_RECORD')"><i v-if="tagsrecord" class="curNewMessage"></i><i class="el-collapse-item__arrow el-icon-arrow-right"></i>笔录</div> -->
                <div class="wodk_item" v-if="workShow.MEDIATION_RECORD_SHOW" @click="openPartyBook('MEDIATION_RECORD')"><i class="curNewMessage"></i><i class="el-collapse-item__arrow el-icon-arrow-right"></i>笔录</div>
                <div class="wodk_item" v-if="workShow.MEDIATION_BOOK_SHOW" @click="openPartyBook('MEDIATION_BOOK')"><i class="curNewMessage"></i><i class="el-collapse-item__arrow el-icon-arrow-right"></i>仲裁调解书</div>
                <div class="wodk_item" v-if="workShow.MEDIATION_SEND_RECEIPT_SHOW && comdata.roleType !== 'OTHER'" @click="openPartyBook('SEND_RECEIPT')"><i class="curNewMessage"></i><i class="el-collapse-item__arrow el-icon-arrow-right"></i>送达回证</div>
                <!-- <div v-if="userDocumentStatus.length>2&&!comdata.istemporary" style="text-align: center;">
                        <el-button type="primary" @click="openPartyBook('ALL_DOCUMENT')">一键签名</el-button>
                    </div> -->
            </template>
        </div>
        <div v-if="!recordFlag && noDataAttendantRecord" class="wodk_menu">
            <template>
                <div style="text-align: center;">
                    暂无笔录
                </div>
            </template>
        </div>
        <!-- <noterecord ref="comVideoRecord" v-model="comdata" @comcallback="dispatchNotice"></noterecord> -->
        <mediatbook ref="commediatbook" :comdata="comdata" :resdata='mediatorHelpList' @comcallback="mediatorDispatchNotice"></mediatbook>
        <partybook ref="compartybook" v-model="comdata" @comcallback="partyDispatchNotice"></partybook>
        <!-- <judicial ref="comJudicial"></judicial> -->
        <!-- <judicial-user ref="comjudicialUser" :comdata="comdata" @comcallback="partyDispatchNotice"></judicial-user> -->
        <!-- <onekeywrap ref="onekeySelect" :meeting="true" @meetingCallBack="mediatorDispatchNotice"></onekeywrap> -->
        <!-- <fast-sign-book ref="fastsignbook" :comtype="'signbook'"></fast-sign-book> -->
    </el-tab-pane>
    <el-dialog class="meetinginvite" title="邀请观摩" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" width="400px">
        <div class="md-wrap">
            <el-form :model="invite" :rules="inviterules" ref="invite" label-width="80px" class="demo-ruleForm">
                <el-form-item label="手机号:" prop="tel">
                    <el-input v-model="invite.tel" placeholder="请输入手机号"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <!-- <div slot="footer" class="dialog-footer">
                <el-button class="meeting_button_primary" type="primary" @click="inviteSendmesg" :disabled="buttonStatus" :loading="BtnLoading">发送</el-button>
            </div> -->
    </el-dialog>

        <el-dialog class="detail-record" :title="dialogTittle" :close-on-click-modal=false :visible.sync="dialogVisible" :modal-append-to-body="false" :before-close="recordClose" width="760px">
            <!-- 上传调解笔录 -->
           <a download="bl.png" class="download" href="https://szwzc-1255516392.cos.ap-chengdu.myqcloud.com/%E5%BA%AD%E5%AE%A1%E7%AC%94%E5%BD%950213%E6%9C%80%E6%96%B0.doc">下载模板</a>
            <br>
            <br>
            <div class="vb">
                <el-upload
                    class="upload-demo"
                    ref="uploadRecord"
                    :action="fileUploads.actionUrl"
                    :data="fileUploads.fileData"
                    :accept="fileUploads.acceptType"
                    :headers="fileUploads.flk"
                    :http-request="handleRequestRecord"
                    :auto-upload="false"
                    :on-change="handleRecord"
                    :limit="2"
                    :file-list="fileUploads.fileListData"
                    >
                    <el-button size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload__tip">请上传.pdf,.doc,.docx文件。</div>
                </el-upload>
            </div>
            
            <div v-if="!signFlag"  slot="footer" class="dialog-footer">
                <el-button @click="sendRecord" class="btnlr-gradient" :disabled="uploadSendStatus.buttonStatusRecord">发送</el-button>
            </div>
            <div v-if="signFlag"  slot="footer" class="dialog-footer">
                <el-button  v-if="!isSignFlag"  @click="openSign" type="primary">签署</el-button>
                <el-button v-if="isSignFlag"  @click="openSign" disabled type="primary">已签署</el-button>
            </div>
            
            <!-- END -->
            <el-dialog
                width="345px"
                title="扫描二维码"
                :visible.sync="innerVisible"
                :close-on-click-modal=false
                :before-close="handleClose"
                append-to-body>
                <img :src="weixincode"> 
                <div class="dialog-footer">
                    <el-button type="primary" @click="sendout('innerVisible')" :disabled="buttonStatus">已经完成手写签名</el-button>
                </div>
            </el-dialog>
        </el-dialog>
        <el-dialog class="detail-record" :title="dialogTittleMediation" :close-on-click-modal=false :visible.sync="dialogVisibleMediation" :modal-append-to-body="false" :before-close="recordClose" width="760px">
            <!-- 上传仲裁书 -->
            <a download="zctjs.png" class="download" href="https://szwzc-1255516392.cos.ap-chengdu.myqcloud.com/%E4%BB%B2%E8%A3%81%E8%B0%83%E8%A7%A3%E4%B9%A60213%E6%9C%80%E6%96%B0.doc">下载模板</a>
            <br>
            <br>
            <div class="vb">
                <el-upload
                    class="upload-demo"
                    ref="uploadMediationBook"
                    :action="fileUploads.actionUrl"
                    :data="fileUploads.fileData"
                    :accept="fileUploads.acceptType"
                    :headers="fileUploads.flk"
                    :http-request="handleRequestMedia"
                    :on-change="handleMediation"
                    :limit="2"
                    :file-list="fileUploads.fileListMediation"
                    :auto-upload="false"
                    >
                    <el-button size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload__tip">请上传.pdf,.doc,.docx文件。</div>
                </el-upload>
            </div>
            
            <div v-if="!signFlag" slot="footer" class="dialog-footer">
                <el-button @click="sendMediationBook" class="btnlr-gradient" :disabled="uploadSendStatus.buttonStatusMediationBook">发送</el-button>
            </div>
        </el-dialog>
        <el-dialog class="detail-record" :title="dialogTittleEnv" :close-on-click-modal=false :visible.sync="dialogVisibleEnv" :modal-append-to-body="false" :before-close="recordClose" width="760px">
            <!-- 上传送达回证 -->
            <a download="sdhz.png" class="download" href="https://szwzc-1255516392.cos.ap-chengdu.myqcloud.com/%E9%80%81%E8%BE%BE%E5%9B%9E%E8%AF%81.doc">下载模板</a>
            <br>
            <br>
            <div class="vb">
                <el-upload
                    class="upload-demo"
                    ref="uploadSendReceive"
                    :action="fileUploads.actionUrl"
                    :data="fileUploads.fileData"
                    :accept="fileUploads.acceptType"
                    :headers="fileUploads.flk"
                    :http-request="handleRequestEnv"
                    :on-change="handleEnv"
                    :limit="2"
                    :file-list="fileUploads.fileListEnv"
                    :auto-upload="false"
                    >
                    <el-button size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload__tip">请上传.pdf,.doc,.docx文件。</div>
                </el-upload>
            </div>
            
            <div v-if="!signFlag" slot="footer" class="dialog-footer">
                <el-button @click="sendEnv" class="btnlr-gradient" :disabled="uploadSendStatus.buttonStatusSendReceive">发送</el-button>
            </div>
        </el-dialog>
    </el-dialog>
    <el-dialog class="detail-record" :title="dialogTittleMediation" :close-on-click-modal=false :visible.sync="dialogVisibleMediation" :modal-append-to-body="false" :before-close="recordClose" width="760px">
        <!-- 上传仲裁书 -->
        <a download="zctjs.png" class="download" href="https://szwzc-1255516392.cos.ap-chengdu.myqcloud.com/%E4%BB%B2%E8%A3%81%E8%B0%83%E8%A7%A3%E4%B9%A60213%E6%9C%80%E6%96%B0.doc">下载模板</a>
        <br>
        <br>
        <div class="vb">
            <el-upload class="upload-demo" ref="uploadMediationBook" :action="fileUploads.actionUrl" :data="fileUploads.fileData" :accept="fileUploads.acceptType" :headers="fileUploads.flk" :http-request="handleRequestMedia" :on-change="handleMediation" :limit="2" :file-list="fileUploads.fileListMediation" :auto-upload="false">
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">请上传.pdf,.doc,.docx文件。</div>
            </el-upload>
        </div>

        <div v-if="!signFlag" slot="footer" class="dialog-footer">
            <el-button @click="sendMediationBook" class="btnlr-gradient" :disabled="uploadSendStatus.buttonStatusMediationBook">发送</el-button>
        </div>
    </el-dialog>
    <el-dialog class="detail-record" :title="dialogTittleEnv" :close-on-click-modal=false :visible.sync="dialogVisibleEnv" :modal-append-to-body="false" :before-close="recordClose" width="760px">
        <!-- 上传送达回证 -->
        <a download="sdhz.png" class="download" href="https://szwzc-1255516392.cos.ap-chengdu.myqcloud.com/%E9%80%81%E8%BE%BE%E5%9B%9E%E8%AF%81.doc">下载模板</a>
        <br>
        <br>
        <div class="vb">
            <el-upload class="upload-demo" ref="uploadSendReceive" :action="fileUploads.actionUrl" :data="fileUploads.fileData" :accept="fileUploads.acceptType" :headers="fileUploads.flk" :http-request="handleRequestEnv" :on-change="handleEnv" :limit="2" :file-list="fileUploads.fileListEnv" :auto-upload="false">
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">请上传.pdf,.doc,.docx文件。</div>
            </el-upload>
        </div>

        <div v-if="!signFlag" slot="footer" class="dialog-footer">
            <el-button @click="sendEnv" class="btnlr-gradient" :disabled="uploadSendStatus.buttonStatusSendReceive">发送</el-button>
        </div>
    </el-dialog>
    <el-dialog class="document-sign" title="文书签名" :close-on-click-modal=false :visible.sync="documentVisible" :modal-append-to-body="false" width="494px">
        <div class="sign-top">
            <img :src="wxSignCode" alt="">
            <div class="sign-discrible">
                <el-radio v-model="selectSign" label="hanleSign">手写签名</el-radio>
                <div class="explain">说明：</div>
                <div class="sort">
                    <span class="num">1</span>
                    <span>用微信</span>
                    <span class="scan">扫描左方二维码</span>
                </div>
                <div class="sort">
                    <span class="num">2</span>
                    <span>前往微信小程序完成手写签名</span>
                </div>
            </div>
        </div>
        <div class="line"></div>
        <div class="sign-top sign-line">
            <img v-if="holdSignFlag" :src="holdSignCode" alt="">
            <div v-if="!holdSignFlag" class="hold-sign">待签名</div>
            <div class="sign-discrible">
                <el-radio v-model="selectSign" label="resetSgin">使用预留签名</el-radio>
                <span v-if="!holdSignFlag" @click="noSet" class="no-set">未设置</span>
                <div class="explain">说明：</div>
                <div class="sort reset">
                    <span>文书直接使用已有的“文书签名”</span>
                </div>
                <div class="sort reset">
                    <span>可在个人中心-账号设置下修改</span>
                </div>
            </div>
        </div>
        <div @click="endSign" class="end">完成</div>
    </el-dialog>
</el-tabs>
</template>

<script>
// import onekeywrap from '@/module/index/pages/mediator/components/onekeywrap.vue'
// import fastSignBook from './fastSignBook'
import mediatbook from './mediatbook.vue'
// import noterecord from './noteRecord.vue'
import partybook from './partyBook.vue'
import caseinfo from './insideCaseInfo.vue'
// import status from './status.vue'
// import judicial from './judicial.vue'
// import judicialUser from './judicialUser.vue'
import axios from 'axios'
import config from '@/config/config'
import IFlyIatSession from '@/utils/iat.js'
import {
    getMeetingDetail,
    getMediationInfo,
    clickAllDownLoad,
    getClerkRecord,
    saveClerkRecord,
    sendClerkRecord,
    signatureConfirmInfo,
    clerkConfirmQrCode,
    clerkConfirm,
    clerkRecordAttaList,
    getMediationWorkbenchs,
    getVoiceRecogKey,
    getArbitrationBookByUser,
    uploadClerkRecord,
    sendArbitrationBook,
    sendDocBook
} from '@/api/meeting'
import {
    searchLoginUserInfo
} from '@/api/userCenter'
import {
    dateformat,
    setStore,
    getStore,
    removeStore,
    getStoreSession
} from '@/utils/utils.js'
import {
    ERR_OK
} from '@/api/reConfig'
export default {
    model: {
        prop: 'comdata',
        event: 'change'
    },
    data() {
        return {
            BtnLoading: false,
            singleMeetingId: 0,
            activeName: 'first',
            msgs: [],
            inputMessage: "",
            ismember: false,
            insideInfoCaseId: 0,
            caseinfoCaseId: 0,
            userID: '',
            caseStatus: '',
            userDocumentStatus: [],
            detailcaseinfo: {},
            workbenchstatus: false,
            viewrecord: true, // 用户显示调解笔录
            tagsrecord: false, // 用户未签名调解笔录显示红点
            userDocumentType: {
                "MEDIATION_BOOK": '调解协议',
                "NO_DISSENT_MEDIATION_SCHEME": '无异议调解方案',
                "UNDISPUTED_FACT": '无争议事实确认',
                "JUDICIAL_CONFIRM_APPLY_BOOK": '司法确认申请书'
            }, // 用户协议书
            loadingcom: false,
            docket: false,
            memberstype: {
                "LITIGANT_WITNESS": "证人",
                "LITIGANT_THIRD": "第三人",
                "MEDIATOR": "工作人员",
                "APPLICANT": '申请人',
                "APPLICANT_AGENT": '申请人代理人',
                "LITIGANT": '参会人',
                "RESPONDENT": '被申请人',
                "RESPONDENT_AGENT": '被申请人代理人',
                'OTHER': '其他人',
                "PETITION_AGENT": '信访代理人',
                'MEDIATOR_HELP_TEMPORARY': '协助调解员',
                'MEDIATOR_HELP': '协助调解员',
                'INVITATION_WATCHER': '观摩人',
                'INVITATION_WATCHER2': '仲裁员'
            },
            iflylatSerStatus: false, // 是否已经建立链接
            mic_pressed: false,
            iflylatStatus: false, // 是否开起语音转文字,
            currentAudioStatus: true, // 当前语音是否开启
            voiceDiscernOnce: true, // 如果进入的会议已经开启语音识别 执行一次语音识别开启
            dialogVisible: false,
            curMeetingType: '',
            invite: {
                tel: ''
            },
            inviterules: {
                tel: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    },
                    {
                        len: 11,
                        message: '请输入11位手机号',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: '手机号输入错误',
                        trigger: 'blur'
                    }
                ]
            },
            messagePageIndex: 1,
            messageTotalPages: '',
            onceLoadMessage: true,
            messageListLoad: true,
            messageListBody: '',
            workbenchsList: [],
            videosList: [],
            documentsList: [],
            mediatorHelpList: [],
            // onlineStatus:'',
            requestingPushers: {},
            //笔录
            formtype :true,
            sendButtonStatus : null,
            saveButtonStatus : null,
            dialogVisibleMediation: false,  //仲裁调解书
            dialogVisibleEnv: false,    //送达回证
            innerVisible:false,
            documentVisible:false,
            selectSign:'hanleSign',
            weixincode: '',
            buttonStatus: false,
            saveBtnLoading:false,
            userData:{},
            documentId:'',
            loginUserId:0,
            attendFlag :false,
            createdFlag :false,
            signFlag:false,
            wxSignCode:"",
            holdSignFlag:false,
            recordAttaList:[],
            recordFlag:false,
            mediationForm: {
                time: '',
                location: '',
                content: '',
                clerkPersonal: [{
                    userName: ""
                }]
            },
            mediationrules: {
                // name: [
                //     { required: true, message: '请输入申请人姓名', trigger: 'blur' }
                // ],
                // location: [
                //     { required: true, message: '请输入地址', trigger: 'blur' }
                // ],
                // time: [
                //     { required: true, message: '请输入时间', trigger: 'blur' }
                // ],
                content: [{
                    required: true,
                    message: '请输入笔录',
                    trigger: 'blur'
                }]
            },
            fileUploads: {
                actionUrl: config.baseURL + '/gzzc/clerkRecord/uploadClerkRecord',
                acceptType: '.pdf,.doc,.docx',
                flk: {
                    JWTToken: getStore('flk'),
                    cType: 'PC',
                    appName: 'gzzc'
                },
                fileData: {},
                fileDataMediation: {},
                fileDataEnv: {},
                fileListData: [],
                fileListMediation: [],
                fileListEnv: []
            },
            dialogTittle: "",
            dialogTittleMediation: '',
            dialogTittleEnv: '',
            isSignFlag: false,
            noDataAttendantRecord: false,
            signResetFlag: false,
            currentMicStatus: true,
            MEDIATION_BOOK_USER_SHOW: false,
            workShow: {
                MEDIATION_BOOK_SHOW: false,
                MEDIATION_RECORD_SHOW: false,
                MEDIATION_SEND_RECEIPT_SHOW: false
            },
            uploadSendStatus: {
                buttonStatusRecord: false,
                buttonStatusMediationBook: false,
                buttonStatusSendReceive: false
            }
        }
    },
    components: {
        'caseinfo': caseinfo,
        'mediatbook': mediatbook,
        'partybook': partybook,
        // 'noterecord':noterecord,
        //'status': status,
        // 'judicial': judicial,
        // 'judicialUser':judicialUser,
        // 'fastSignBook':fastSignBook,
        // 'onekeywrap':onekeywrap
    },
    props: ['comdata', 'wselement', 'meetingId', 'singleCaseId'],
    mounted() {
        this.singleMeetingId = this.meetingId
        this.insideInfoCaseId = this.singleCaseId
        this.caseinfoCaseId = this.comdata.caseID //重新定义caseid传入上传文件接口
        this.messageListBody = this.$refs.messageListBox;

        this.IFlyIatSessionInit()
    },
    created() {
        this.loginUserId = this.comdata.userID
    },
    watch: {
        comdata: {
            handler: function (newData, oldData) {
                let self = this,
                    currentDocumentsData = []
                self.$nextTick(function () {
                    self.listMessage(self.messagePageIndex);
                    if (!newData.iswatcher) {
                        getMediationInfo({
                            "lawCaseId": newData.caseID
                        }, self.comdata.invite).then((res) => {
                            if (res.data.code === 1000) {
                                self.detailcaseinfo = res.data.data;
                                //self.mediatorHelpList = res.data.data.mediatorHelpList;
                                self.docket = res.data.data.docket;
                                //self.getMediatorDocuments(newData.caseID);
                                //self.queryMeetingList(newData.caseID,newData.meetingID)
                                if (!newData.mediatorself) {
                                    // self.getMediationWorkbenchs(newData.caseID)
                                }
                                self.$emit('getOrgid', res.data.data.orgId)
                            }
                        })
                        // if(!newData.mediatorself) {
                        //     viewMediationRecord({"lawCaseId": newData.caseID,"meetingId": newData.meetingID}).then((res) => {
                        //         self.viewrecord = Boolean(res.data.data.sendStatus)?true:false
                        //         if(res.data.data.lawWholeConfirms){
                        //             res.data.data.lawWholeConfirms.forEach((element,index,array) => {
                        //                 if(element.userId == newData.userID) {
                        //                     if(!Boolean(element.confirm)){
                        //                         self.tagsrecord = true
                        //                         self.workbenchstatus = true
                        //                         console.log('----调解笔录-----')
                        //                     }
                        //                 }
                        //             })
                        //         }
                        //     })
                        // }
                    }
                });
            },
            deep: true
        }
    },
    methods: {
        getVoiceTonken() {
            if (!this.comdata.iswatcher) {
                this.isSuccess = false
                getVoiceRecogKey({}, this.comdata.invite).then(res => {
                    if (res.data.code == 1000) {
                        this.voiceToken = res.data.data.key
                        this.voiceUid = res.data.data.uid
                        if (this.isRestart) {
                            this.IFlyLatPlay()
                        }
                    }
                    this.isSuccess = true
                }).catch((err) => {
                    this.isSuccess = true
                })
            }
        },
        /*****笔录开始** */
        //笔录材料
        clerkRecordList() {
            clerkRecordAttaList({
                objectId: this.singleMeetingId,
                objectType: 'MEDIATION'
            }, this.comdata.invite).then(res => {
                this.recordAttaList = res.data.data
                this.recordAttaList.map(item => { //工作台根据是否有文书之类展示按钮
                    if (item.sign === 'ARBITRATION_BOOK') {
                        this.workShow.MEDIATION_BOOK_SHOW = true
                    }
                    if (item.sign === 'MEDIATION_RECORD') {
                        this.workShow.MEDIATION_RECORD_SHOW = true
                    }
                    if (item.sign === 'SEND_RECEIPT') {
                        this.workShow.MEDIATION_SEND_RECEIPT_SHOW = true
                    }
                })
                if (this.recordAttaList && this.recordAttaList.length > 0) {
                    this.recordFlag = true
                }
                this.getMeetingDetail()
            }, erro => {

            })
        },
        //制作笔录
        dialogRecord() {
            this.dialogVisible = true
            // this.getMediationRecord()
            this.searchLoginUserInfo()
        },
        //上传调解仲裁书
        dialogMedBook() {
            this.dialogVisibleMediation = true
            this.dialogTittleMediation = '上传仲裁调解书'
        },
        //上传送达回证
        dialogEnv() {
            this.dialogVisibleEnv = true
            this.dialogTittleEnv = '上传送达回证'
        },
        formStatus() {
            this.formtype = false
            this.sendButtonStatus = null
            this.saveButtonStatus = null
        },
        sendout() {
            if (this.selectSign == 'resetSgin') {
                searchLoginUserInfo({}, this.comdata.invite).then(res => {
                    if (res.data.code === 1000) {
                        this.userData = res.data.data
                        if (res.data.data.signatureFileUrl) {
                            this.holdSignFlag = true
                            this.holdSignCode = res.data.data.signatureFileUrl
                            this.innerVisible = false;
                        }
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: err
                    })
                })

            } else {
                this.buttonStatus = true
                signatureConfirmInfo({
                    documentIds: [this.documentId]
                }, this.comdata.invite).then((res) => {
                    if (res.data.code === 1000) {
                        if (res.data.data) {
                            this.$message({
                                message: '签名成功',
                                type: 'success'
                            });
                            setTimeout(() => {
                                this.innerVisible = false;
                                this.dialogVisible = false;
                                this.formtype = true;
                            })

                        } else {
                            this.$message({
                                message: '未完成签名',
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                    this.buttonStatus = false
                }, (error) => {
                    this.buttonStatus = false
                })
            }
        },
        endSign() {
            if (this.selectSign == 'hanleSign') {
                signatureConfirmInfo({
                    documentIds: [this.documentId]
                }, this.comdata.invite).then((res) => {
                    if (res.data.code === 1000) {
                        if (res.data.data) {
                            this.$message({
                                message: '签名成功',
                                type: 'success'
                            });
                            setTimeout(() => {
                                this.dialogVisible = false
                                this.documentVisible = false
                                this.formtype = true
                            })
                        } else {
                            this.$message({
                                message: '未完成签名',
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                    this.buttonStatus = false
                }, (error) => {
                    this.buttonStatus = false
                })

            } else {
                clerkConfirm(this.documentId, {}, this.comdata.invite).then(res => {
                    if (res.data.code === 1000) {
                        if (!res.data.data.message) {
                            this.$message({
                                message: '签名成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                message: '您已同意并确认调解笔录',
                                type: 'warning'
                            });
                        }
                        setTimeout(() => {
                            this.dialogVisible = false
                            this.documentVisible = false
                            this.formtype = true
                        })
                    } else if (res.data.code === 1003) {
                        this.noSet()
                        this.signResetFlag = true
                    }
                }, erro => {
                    this.$message.error(res.data.message)
                })
            }
        },
        handleClose(done) {
            if (!this.signFlag) {
                this.buttonStatus = true
                this.sendout()
            } else {
                searchLoginUserInfo({}, this.comdata.invite).then(res => {
                    if (res.data.code === 1000) {
                        this.userData = res.data.data
                        if (res.data.data.signatureFileUrl) {
                            this.holdSignFlag = true
                            this.holdSignCode = res.data.data.signatureFileUrl
                        }

                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: err
                    })
                })
            }
            this.innerVisible = false
        },
        recordClose(done) {
            this.formtype = true
            this.$refs["mediationForm"] && this.$refs["mediationForm"].clearValidate()
            done()
        },
        refresh() {
            this.getMediationRecord()
        },
        getMediationRecord() {
            //this.curmeetingRecordId = id
            getClerkRecord({
                bizId: this.singleMeetingId == "" ? null : this.singleMeetingId,
                docId: this.documentId == "" ? null : this.documentId,
                meetId: this.singleMeetingId == "" ? null : this.singleMeetingId
            }, this.comdata.invite).then((res) => {
                if (res.data.code == 1000) {
                    let tempContent = res.data.data.content
                    this.mediationForm = res.data.data;
                    tempContent = tempContent.replace(/^\n+/g, "");
                    if (tempContent.indexOf('\n\n') > 0) {
                        tempContent = tempContent.replace(/[\n]{2}/g, "\n")
                    }
                    this.mediationForm.content = tempContent
                    this.documentId = res.data.data.docId
                    // this.lawWholeConfirms = res.data.data.lawWholeConfirms;
                    this.sendButtonStatus = res.data.data.sendStatus;
                    this.saveButtonStatus = res.data.data.docId;
                    if (!Boolean(res.data.data.docId)) this.formStatus();
                    if (this.attendFlag) {
                        signatureConfirmInfo({
                            documentIds: [this.documentId]
                        }, this.comdata.invite).then((res) => {
                            if (res.data.code === 1000) {
                                if (res.data.data == '签名成功') {
                                    this.isSignFlag = true
                                } else if (res.data.data && res.data.data != '签名成功') {
                                    this.$message({
                                        message: res.data.data,
                                        type: 'warning'
                                    });
                                }
                            } else {

                            }
                        }, (error) => {
                            this.$message.error(error.data.message)
                        })
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            }, (error) => {

            })
        },
        handleRequestRecord(file) {
            console.log(file);
            this.fileUploads.filedata.append('uploadFile', file.file)
        },
        handleRequestMedia(file) {
            this.fileUploads.fileDataMediation.append('uploadFile', file.file)
        },
        handleRequestEnv(file) {
            this.fileUploads.fileDataEnv.append('uploadFile', file.file)
        },
        handleRecord(file) {
            this.fileUploads.fileListData = [file]
        },
        handleMediation(file) {
            this.fileUploads.fileListMediation = [file]
        },
        handleEnv(file) {
            this.fileUploads.fileListEnv = [file]
        },
        sendEnv() {
            //上传送达回证
            let params = {
                docId: this.documentId || '',
                meetingId: this.singleMeetingId,
                caseId: this.comdata.caseID,
                docType: 'SEND_RECEIPT'
            }
            let tempData = this.fileUploads.fileDataEnv
            this.fileUploads.fileDataEnv = new FormData()
            this.$refs.uploadSendReceive.submit();
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const element = params[key];
                    this.fileUploads.fileDataEnv.append(key, element)
                }
            }
            if (!this.fileUploads.fileDataEnv.has("uploadFile")) return //必须在按钮设置为buttonStatusSendReceive= true之前
            this.BtnLoading = true;
            this.uploadSendStatus.buttonStatusSendReceive = true;
            sendDocBook(this.fileUploads.fileDataEnv).then((res) => {
                if (res.data.code == 1000) {
                    this.$message({
                        message: '发送成功',
                        type: 'success'
                    });
                    this.dialogVisibleEnv = false
                    // this.documentId = res.data.data.documentId
                    // this.weixincode = res.data.data.launchSign+"/gzzc"  
                } else {
                    this.$message.error(res.data.message)
                }
                this.BtnLoading = false;
                this.uploadSendStatus.buttonStatusSendReceive = false;
            })
        },
        sendMediationBook() {
            //上传调解书
            let params = {
                docId: this.documentId || '',
                meetingId: this.singleMeetingId,
                caseId: this.comdata.caseID,
                docType: 'ARBITRATION_BOOK'
            }
            let tempData = this.fileUploads.fileDataMediation
            this.fileUploads.fileDataMediation = new FormData()
            this.$refs.uploadMediationBook.submit(); //上传获取文件调用
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const element = params[key];
                    this.fileUploads.fileDataMediation.append(key, element)
                }
            }
            if (!this.fileUploads.fileDataMediation.has("uploadFile")) return //必须在按钮设置为buttonStatusMediationBook= true之前
            this.BtnLoading = true;
            this.uploadSendStatus.buttonStatusMediationBook = true;
            sendDocBook(this.fileUploads.fileDataMediation).then((res) => {
                if (res.data.code == 1000) {
                    this.$message({
                        message: '发送成功',
                        type: 'success'
                    });
                    this.dialogVisibleMediation = false
                    this.documentId = res.data.data.documentId
                    this.weixincode = res.data.data.launchSign + "/gzzc"
                    // this.innerVisible = true
                    this.mediatorDispatchNotice('MEDIATION_BOOK')
                } else {
                    this.$message.error(res.data.message)
                }
                this.BtnLoading = false;
                this.uploadSendStatus.buttonStatusMediationBook = false;
            })
        },
        sendRecord() {
            //上传笔录
            let params = {
                docId: this.documentId || '',
                meetingId: this.singleMeetingId,
                caseId: this.comdata.caseID,
                docType: 'MEDIATION_RECORD'
            }
            let tempData = this.fileUploads.filedata
            this.fileUploads.filedata = new FormData()
            this.$refs.uploadRecord.submit();
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const element = params[key];
                    this.fileUploads.filedata.append(key, element)
                }
            }
            if (!this.fileUploads.filedata.has("uploadFile")) return //必须在按钮设置为buttonStatusRecord = true之前
            this.BtnLoading = true;
            this.uploadSendStatus.buttonStatusRecord = true
            sendDocBook(this.fileUploads.filedata).then((res) => {
                if (res.data.code == 1000) {
                    this.documentId = res.data.data.documentId
                    this.weixincode = res.data.data.launchSign + "/gzzc"
                    // this.innerVisible = true
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.dialogVisible = false

                } else {
                    this.$message.error(res.data.message)
                }
                this.uploadSendStatus.buttonStatusRecord = false
                this.BtnLoading = false;
            })
        },
        saveRecord() {
            if (this.formtype) return;

            if (this.mediationForm.remark == null) {
                this.mediationForm.remark = 0
            }
            let params = {
                bizId: this.mediationForm.bizId,
                bizNo: this.mediationForm.bizNo,
                content: this.mediationForm.content,
                disputeType: "MEDIATION",
                docId: '',
                location: this.mediationForm.location,
                mediatorName: this.mediationForm.clerkPersonal[0].userName,
                meetId: this.singleMeetingId,
                orgId: this.userData.orgId,
                orgName: this.userData.orgName,
                remark: this.mediationForm.remark,
                time: this.mediationForm.time
            }
            this.$refs['mediationForm'].validate((valid) => {
                if (valid) {
                    this.buttonStatus = true
                    this.saveBtnLoading = true;
                    saveClerkRecord(params, this.comdata.invite).then((res) => {
                        if (res.data.code == 1000) {
                            this.documentId = res.data.data.documentId;
                            this.formtype = true;
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.buttonStatus = false;
                            this.saveBtnLoading = false;
                        } else {
                            this.$message.error(res.data.message)
                        }

                    })
                }
            });
        },
        searchLoginUserInfo() {
            searchLoginUserInfo({}, this.comdata.invite).then(res => {
                if (res.data.code === 1000) {
                    this.userData = res.data.data
                    if (res.data.data.signatureFileUrl) {
                        this.holdSignFlag = true
                        this.holdSignCode = res.data.data.signatureFileUrl
                    }
                }
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err
                })
            })
        },
        getMeetingDetail() {
            let params = {
                caseId: this.insideInfoCaseId,
                meetingId: this.singleMeetingId
            }
            getMeetingDetail(params, this.comdata.invite).then(res => {
                if (res.data.code == ERR_OK) {
                    let dataList = res.data.data
                    // 容错处理Cannot read property 'creatorId' of null
                    if (!dataList.mediationCaseBaseDTO) {
                        dataList.mediationCaseBaseDTO = {}
                    } else if (!dataList.meetingDetailResDTO) {
                        dataList.meetingDetailResDTO = {}
                    }
                    if (this.loginUserId == dataList.mediationCaseBaseDTO.creatorId || this.loginUserId == dataList.meetingDetailResDTO.creatorId) {
                        this.createdFlag = true
                        this.dialogTittle = '制作笔录'
                    }
                    dataList.meetingDetailResDTO.mediationRoomUserList.forEach(element => {
                        if (element.userId == this.loginUserId && this.loginUserId != dataList.mediationCaseBaseDTO.creatorId && this.loginUserId != dataList.meetingDetailResDTO.creatorId && (this.recordAttaList && this.recordAttaList.length > 0)) {
                            this.attendFlag = true
                            this.dialogTittle = '笔录签署'
                        }
                        if (element.userId == this.loginUserId && this.loginUserId != dataList.mediationCaseBaseDTO.creatorId && this.loginUserId != dataList.meetingDetailResDTO.creatorId) {
                            this.noDataAttendantRecord = true
                        }
                    })
                }
            }, erro => {

            })
        },
        //用户文书签名

        openDocumentSign() {
            this.signFlag = true
            this.dialogRecord()
        },
        //未设置
        noSet() {
            this.innerVisible = true
            let instance
            instance = axios.create({
                headers: {
                    'JWTToken': getStore('flk'),
                    'cType': 'PC',
                    'appName': 'gzzc'
                }
            });
            instance({
                method: 'post',
                url: '/gzzc/signature/showSignNameQrCode',
                data: {},
                responseType: 'arraybuffer'
            }).then(res => {
                this.weixincode = window.URL.createObjectURL(new Blob([res.data], {
                    type: 'image/png;charset=UTF-8'
                }));
            })
        },
        //弹出签名弹窗
        openSign() {
            this.documentVisible = true
            //获取当事人签名二维码
            clerkConfirmQrCode({
                docId: this.documentId
            }, this.comdata.invite).then(res => {
                if (res.data.code == ERR_OK) {
                    this.wxSignCode = res.data.data.launchSign + '/gzzc'
                }

            }, erro => {

            })
        },
        /*****笔录结束** */
        queryMeetingList(caseId, mettingId) {
            queryMeetingList({
                "caseId": caseId
            }, this.comdata.invite).then((res) => {
                if (res.data.code === ERR_OK) {
                    this.videosList = res.data.data;
                    if (this.videosList) {
                        for (let i = 0; i < this.videosList.length; i++) {
                            if (this.videosList[i].id == mettingId) {
                                this.curMeetingType = this.videosList[i].meetingType == 'MEETING_MEDIATE' ? '调解笔录' : '调查笔录'
                                break;
                            }
                        }
                    }
                }
            })
        },
        getMediationWorkbenchs(caseId) {
            let currentDocumentsData = []
            getMediationWorkbenchs({
                "lawCaseId": caseId,
                "workbenchModel": true
            }, this.comdata.invite).then((res) => {
                if (res.data.code === ERR_OK) {
                    this.workbenchsList = res.data.data;
                    if (this.workbenchsList.length > 0) {
                        this.workbenchsList.forEach((element, index, array) => {
                            if ((element.documentType == "MEDIATION_RECORD" || element.documentType == "INQUIRE_RECORD") && element.meetingId == this.comdata.meetingID) {
                                currentDocumentsData.push(element)
                                if (element.status) {
                                    this.workbenchstatus = true
                                } else {
                                    element.status = false
                                }
                            } else if ((element.documentType != "MEDIATION_RECORD") || (element.documentType != "INQUIRE_RECORD")) {
                                if (element.status) {
                                    this.workbenchstatus = true
                                } else {
                                    element.status = false
                                }
                                currentDocumentsData.push(element)
                            }
                        })
                        this.userDocumentStatus = currentDocumentsData
                    } else {
                        this.userDocumentStatus = [];
                        this.workbenchstatus = false
                    }
                }
            }, (error) => {
                console.log(error);
            })
        },
        getMediatorDocuments(caseId) {
            getMediatorDocuments({
                "caseId": caseId
            }, this.comdata.invite).then((res) => {
                if (res.data.code === ERR_OK) {
                    this.documentsList = res.data.data;
                }
            }, (error) => {
                console.log(error);
            })
        },
        listMessage(pageindex) { // 拉取消息记录
            let self = this,
                data, msgdata = {};
            self.$emit('sourceMessage', 'public')
            data = {
                pageIndex: pageindex,
                pageSize: 500
            };
            msgdata.event = "LIST_MESSAGE";
            msgdata.data = data;
            self.wselement.send(JSON.stringify(msgdata))
        },
        // 初始化语音转写实例
        IFlyIatSessionInit() {
            if (!this.comdata.iswatcher) {
                let _this = this
                let iflysession = {
                    sendMessage: function (result) {
                        _this.sendMessage(result)
                    },
                    onError: function (code, msg) {
                        _this.iflylatStatus = false
                        _this.$message.error(msg)
                    }
                }
                IFlyIatSession.init(iflysession, _this.comdata.istemporary)
            }
        },
        speechOpen(micStatus) { // 打开语音识别
            if (this.currentMicStatus) { // 当前麦克风未被禁用
                IFlyIatSession.IFlyLatPlay()
            }
        },
        speechColsed() { // 关闭语音识别
            IFlyIatSession.IFlyLatStop()
        },
        speechSwitch() { // 调解员发出语音识别开关
            let self = this,
                msgdata = {},
                data = {};
            // if(this.iflylatStatus){
            //     data = {event: "speech",type: "stop"}
            // }else{
            //     data = {event: "speech",type: "start"}
            // }
            // msgdata.event = "OTHER"
            data = {
                mediaType: "VOICE_DISCERN",
                memberId: this.comdata.userID,
                operator: "MEDIATOR"
            }
            msgdata.event = "SWITCH_MEDIA"
            msgdata.data = data
            self.wselement.send(JSON.stringify(msgdata))
        },
        handleClick(tab) { // 工作台切换
            if (tab.name == "second") {
                this.$refs.comCaseinfo.openDialog(this.comdata.caseID, this.meetingId)
            }
            if (tab.name == "third") {
                this.clerkRecordList()
                // if (!this.comdata.mediatorself) this.getBookData()
            }
        },
        onSendMessageClick() {
            var self = this;
            var msg = this.inputMessage;
            self.inputMessage = "";
            var data = {
                content: msg,
                messageResource: 'HANDLER_INPUT'
            };
            var msgdata = {};
            msgdata.event = "SEND_TEXT";
            msgdata.data = data;
            console.log('#####',msgdata)
            self.wselement.send(JSON.stringify(msgdata))
        },
        sendMessage(msg) {
            let self = this,
                data = {
                    content: msg,
                    messageResource: 'VOICE_DISCERN'
                },
                msgdata = {};
            msgdata.event = "SEND_TEXT";
            msgdata.data = data;
            self.wselement.send(JSON.stringify(msgdata))

        },
        messageScroll(event) {
            console.log(event)
        },
        loadMsgList(data) {
            if (!Boolean(data.list.length)) return;
            let self = this,
                messagelist = [],
                context, t;
            self.messageListLoad = true;
            self.messagePageIndex = Number(self.messagePageIndex) + 1;
            self.messageTotalPages = data.totalPages;
            data.list.forEach((item, index, array) => {
                messagelist.unshift({
                    who: "【" + self.memberstype[item.sender.memberType] + "】" + (item.sender.memberType === 'MEDIATOR' ? '仲裁员' : item.sender.memberName),
                    id: item.sender.memberId,
                    content: item.messageContent,
                    time: this.timestoday(item.createTime),
                    type: item.messageResource
                })
            });
            self.msgs = messagelist.concat(self.msgs);
            if (self.onceLoadMessage) {
                t = setTimeout(function () {
                    self.messageListBody.scrollTop = self.messageListBody.scrollHeight
                }, 200)
                self.messageListBody.addEventListener('scroll', self.pullMessage, false);
            }
            self.onceLoadMessage = false;
            if (self.messagePageIndex > data.totalPages) {
                self.messageListBody.removeEventListener('scroll', self.pullMessage, false);
            }
        },
        pullMessage() {
            let self = this;
            if (self.$refs.messageListBox.scrollTop == 0 && self.messagePageIndex <= self.messageTotalPages && self.messageListLoad) {
                self.messageListLoad = false;
                self.listMessage(self.messagePageIndex);
            }
        },
        uploadMsgList(message) {
            const memberstype = {
                "LITIGANT_WITNESS": "证人",
                "LITIGANT_THIRD": "第三人",
                "MEDIATOR": "工作人员",
                "APPLICANT": '申请人',
                "APPLICANT_AGENT": '申请人代理人',
                "LITIGANT": '参会人',
                "RESPONDENT": '被申请人',
                "RESPONDENT_AGENT": '被申请人代理人',
                'OTHER': '其他人',
                "PETITION_AGENT": '信访代理人',
                'MEDIATOR_HELP_TEMPORARY': '协助调解员',
                'MEDIATOR_HELP': '协助调解员',
                'INVITATION_WATCHER': '观摩人',
                'INVITATION_WATCHER2': '仲裁员'
            }
            this.msgs.push({
                who: "【" + memberstype[message.sender.memberType] + "】" + (message.sender.memberType === 'MEDIATOR' ? '仲裁员' : message.sender.memberName),
                id: message.sender.memberId,
                content: message.messageContent,
                time: this.timestoday(message.createTime),
                type: message.messageResource
            })
            let context = document.getElementById('messageBox')
            let t = setTimeout(function () {
                context.scrollTop = context.scrollHeight
            }, 500)
        },
        inOutRoomList(message) {
            this.msgs.push({
                who: "【系统提示】",
                content: ((message.memberRole == 'MEDIATOR' ? message.memberType : message.memberType + message.memberName) + (message.memberStatus == 'ONLINE' ? '进入视频会议！' : '离开视频会议！')),
                time: this.timestoday(message.memberTime)
            })
            let hash = {}; //数组去重
            this.msgs = this.msgs.reduce((preVal, curVal) => {
                hash[curVal.time] ? '' : hash[curVal.time] = true && preVal.push(curVal);
                return preVal
            }, [])
            let context = document.getElementById('messageBox')
            let t = setTimeout(function () {
                context.scrollTop = context.scrollHeight
            }, 500)
        },
        timestoday(t) {
            var times = new Date(t);
            var ty = times.getFullYear(),
                tm = times.getMonth() + 1,
                td = times.getDate(),
                th = times.getHours(),
                tmt = times.getMinutes(),
                ts = times.getSeconds();
            var ntostring = function (d) {
                if (d.toString().length == 1) {
                    return "0" + d;
                }
                return d;
            }
            return ntostring(th) + ":" + ntostring(tmt) + ":" + ntostring(ts);
        },
        openStatus(command) {
            this.$refs.comStatus.openDialog('调解状态', this.comdata.caseID);

        },
        openRecord() {
            this.$refs.comVideoRecord.openDialog('MEDIATION_RECORD', this.curMeetingType, this.comdata.meetingID, this.comdata.caseID)
        },
        openMedBook(command) {
            let title;
            if (command == 'quit') {
                this.goHomeRouter();
            } else if (command == 'dossier') {
                document.location.href = '/mediator/completed/dossier/' + this.comdata.caseID
            } else if (command == 'JUDICIAL') {
                this.$refs.comJudicial.openDialog('JUDICIAL_CONFIRM_APPLY_BOOK', '司法确认申请书', this.comdata.caseID)
            } else {
                if (command == 'MEDIATION_BOOK') {
                    title = '仲裁调解书'
                    this.$refs.commediatbook.openDialog(command, title, this.comdata.caseID, this.comdata.meetingID)
                } else if (command == 'NO_DISSENT_MEDIATION_SCHEME') {
                    title = '无异议调解方案'
                    this.$refs.commediatbook.openDialog(command, title, this.comdata.caseID)
                } else if (command == 'UNDISPUTED_FACT') {
                    title = '无争议事实确认协议'
                    this.$refs.commediatbook.openDialog(command, title, this.comdata.caseID)
                } else if (command == 'onekeySelect') {
                    title = '一键发送'
                    this.$refs.onekeySelect.openDialog('onekeySelect', '一键发送', this.comdata.caseID)
                }
            }
        },
        openPartyBook(command) {
            let title;
            if (command == 'MEDIATION_BOOK' || command == 'MEDIATION_RECORD' || command == 'SEND_RECEIPT') {
                if (command == 'MEDIATION_BOOK') {
                    title = '仲裁调解书'
                } else if (command == 'MEDIATION_RECORD') {
                    title = '笔录'
                } else if (command == 'SEND_RECEIPT') {
                    title = '送达回证'
                }
                this.$refs.compartybook.openDialog(command, title, this.comdata.caseID, this.detailcaseinfo.currentCaseUserType, this.comdata.meetingID)
            } else if (command == 'COMMITMENT_BOOK') {
                title = '无异议调解方案承诺书'
                this.$refs.compartybook.openDialog('NO_DISSENT_MEDIATION_SCHEME', title, this.comdata.caseID, this.detailcaseinfo.currentCaseUserType)
            } else if (command == 'NO_DISSENT_MEDIATION_SCHEME') {
                title = '无异议调解方案'
                this.$refs.compartybook.openDialog(command, title, this.comdata.caseID, this.detailcaseinfo.currentCaseUserType)
            } else if (command == 'UNDISPUTED_FACT') {
                title = '无争议事实确认协议'
                this.$refs.compartybook.openDialog(command, title, this.comdata.caseID, this.detailcaseinfo.currentCaseUserType)
                // }else if (command == "MEDIATION_RECORD") {
                //     title = '笔录'
                //     this.$refs.comVideoRecord.openDialog('MEDIATION_RECORD',title,this.comdata.meetingID,this.comdata.caseID)
            } else if (command == "INQUIRE_RECORD") {
                title = '调查笔录'
                this.$refs.comVideoRecord.openDialog('INQUIRE_RECORD', title, this.comdata.meetingID, this.comdata.caseID)
            } else if (command == 'JUDICIAL_CONFIRM_APPLY_BOOK') {
                title = '司法确认申请书'
                this.$refs.comjudicialUser.openDialog('judicial', title, this.comdata.caseID, this.detailcaseinfo.currentCaseUserType)
            } else if (command == 'ALL_DOCUMENT') {
                title = '一键签署'
                // this.$refs.compartybook.openDialog('onekey',title, content.meetingId,this.caseId)
                // this.$refs.onekeySelect.openDialog('onekeySelect','一键签名',this.caseId)
                this.$refs.fastsignbook.showCurDialog(this.workbenchsList, this.comdata.caseID, this.comdata.roleType)

            }
        },
        dispatchNotice(opt) { // 调解员/当事人发出广播 - 调解笔录
            let self = this,
                data, msgdata = {}
            if (self.comdata.mediatorself) {
                data = {
                    type: opt.type
                }
            } else {
                data = {
                    event: "paryt",
                    type: opt.type,
                    status: opt.status,
                    userid: self.comdata.userID
                }
                self.getMediationWorkbenchs(self.comdata.caseID)
            }
            msgdata.event = "SEND_BOOK"
            msgdata.data = data
            self.wselement.send(JSON.stringify(msgdata))
        },
        mediatorDispatchNotice(opt) { // 调解员发出广播 - 协议
            let self = this
            let data = {
                type: opt.type
            }
            var msgdata = {}
            msgdata.event = "SEND_BOOK"
            msgdata.data = data
            self.wselement.send(JSON.stringify(msgdata))
        },
        partyDispatchNotice(opt) { // 当事人发出广播 - 协议
            // this.getMediationWorkbenchs(this.comdata.caseID)
            // let self = this
            // let data = {
            //     event: "party",
            //     type: opt.type
            // }
            // var msgdata = {}
            // msgdata.event = "OTHER"
            // msgdata.data = data
            // self.wselement.send(JSON.stringify(msgdata))

        },
        broadcastReceive(opt) { // 接收到的消息
            let param = {}
            try {
                param = JSON.parse(opt)
            } catch (error) {
                param.type = opt
            }
            if (!this.comdata.mediatorself) {
                // if(param.event == "mediator") { // 调解员发出广播
                if (!param.type) {
                    // this.partyWorkbench(true)
                } else {
                    this.openPartyBook(param.type)
                    // this.partyWorkbench()
                }
                // }
            }
            // this.getBookData()
            this.clerkRecordList()
        },
        speechDiscernControl(data, micStatus) { // 语音识别控制
            this.currentMicStatus = micStatus
            if (this.iflylatStatus) {
                this.iflylatStatus = false
                this.speechColsed()
            } else {
                this.iflylatStatus = true
                this.speechOpen()
            }
        },
        speechOpenWithAudio() { // 当事人视频语音被开启时语音识别功能同时开启（仅在语音识别被调解员开启时）
            if (this.iflylatStatus) {
                IFlyIatSession.IFlyLatPlay()
            }
        },
        speechColsedWithAudio() { // 当事人视频语音被关闭时语音识别功能同时关闭（仅在语音识别被调解员开启时）
            if (this.iflylatStatus) {
                IFlyIatSession.IFlyLatStop()
            }
        },
        speechDiscernInit(micStatus) {
            this.currentMicStatus = micStatus
            this.isOnDiscern = true
            if (this.voiceDiscernOnce) {
                this.speechOpen()
                this.iflylatStatus = true
                this.voiceDiscernOnce = false
            }
        },
        partyReceive(opt) { // 当事人接收并执行 - 协议
            if (opt.type == "medbooka") {
                this.openPartyBook('MEDIATION_BOOK')
            } else if (opt.type == "medbookb") {
                this.openMedBook('NO_DISSENT_MEDIATION_SCHEME')
            } else if (opt.type == "medbookc") {
                this.openMedBook('UNDISPUTED_FACT')
            }
            this.partyWorkbench()
        },
        partyWorkbench(ble) {
            let self = this,
                currentDocumentsData = []
            getMediationWorkbenchs({
                "lawCaseId": this.comdata.caseID
            }, self.comdata.invite).then((res) => {
                if (res.data.code === 1000) {
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((element, index, array) => {
                            if (element.documentType == "MEDIATION_RECORD" && element.meetingId == self.comdata.meetingID) {
                                currentDocumentsData.push(element)
                            } else if (element.documentType != "MEDIATION_RECORD") {
                                if (element.status) {
                                    self.workbenchstatus = true
                                } else {
                                    element.status = false
                                }
                                currentDocumentsData.push(element)
                            }
                        })
                        self.userDocumentStatus = currentDocumentsData
                        if (ble) this.currentDocumentSign(currentDocumentsData)
                    }
                }
            })
        },
        currentDocumentSign(data) {
            let currentType
            for (let i = 0; i < data.length; i++) {
                if (data[i].status) {
                    currentType = data[i].documentType
                    break
                }
            }
            this.openPartyBook(currentType)
        },
        changStatushNotice(opt) { // 案件状态改变 退出视频时的去向
            this.caseStatus = opt.type
            console.log(this.caseStatus);
            this.$emit('comcallback', {
                type: opt.type
            })
        },
        openCurrentTabs(name) {
            this.activeName = name
            if (name == "second" && !this.comdata.iswatcher) {
                this.$refs.comCaseinfo.openDialog(this.comdata.caseID, this.meetingId)
            }
            if (name == "third") {
                this.clerkRecordList()
            }
        },
        openInviteDialog() {
            this.dialogVisible = true
        },
        inviteSendmesg() {
            this.BtnLoading = true
            this.buttonStatus = true
            this.$refs['invite'].validate((valid) => {
                if (valid) {
                    inviteSendSms({
                        "caseId": this.comdata.caseID,
                        "meetingId": this.comdata.meetingID,
                        "phone": this.invite.tel
                    }).then((res) => {
                        if (res.data.code === 1000) {
                            this.$message({
                                message: '发送成功',
                                type: 'success'
                            });
                            this.dialogVisible = false
                            this.$refs['invite'].resetFields()
                        } else {
                            this.$message.error(res.data.message)
                        }
                        this.BtnLoading = false
                        this.buttonStatus = false
                    })
                } else {
                    this.buttonStatus = false
                    this.BtnLoading = false
                    return false;
                }
            })
        },
        getBookData(type) { // 判断当事人是否需要获取协议书
            // getArbitrationBookByUser({
            //     caseId: this.$route.query.caseid,
            //     meetingId: this.meetingId,
            // }).then((res) => {
            //     if(res.data.code===1000){
            //         if(res.data.data !== null) {
            // this.MEDIATION_BOOK_USER_SHOW = true
            //         }
            //     }else {
            //         this.MEDIATION_BOOK_USER_SHOW = false
            //         this.$message.error(res.data.message)
            //     }
            // },(error)=>{
            //     console.log(error)
            // })
        },
    },
    beforeDestroy() {
        IFlyIatSession.IFlyLatKill()
    }
}
</script>

<style lang="scss">
.inside_tab {
    height: 100%;

    .el-tabs__nav-wrap {
        height: 60px;
        background-color: #fff;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    }

    .el-tabs__nav {
        display: flex;
        width: 100%;
    }

    .el-tabs__item {
        flex: 1;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        text-align: center;

        .eltablabel {
            font-size: 16px;
            font-weight: 500;
        }
    }

    .el-tabs__active-bar {
        height: 4px;
    }

    .el-tabs__nav-wrap::after {
        height: 0;
    }

    .el-tabs__content {
        height: calc(100% - 75px);
        overflow-y: auto;
    }

    .meeting-right-chatroom {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 1px;

        .meeting-chatroom-list {
            position: absolute;
            top: 0;
            bottom: 125px;
            left: 0;
            right: 0;
            margin: 0;
            padding: 20px;
            background-color: #f8f8f8;
            box-sizing: border-box;
            overflow-y: auto;
        }

        .botcss.meeting-chatroom-list {
            bottom: 165px;
        }

        .meeting-chatroom-list li {
            padding: 10px 0 15px;

        }

        .meeting-chatroom-list li span {
            display: block;
            padding-bottom: 6px;
            color: #888888;
            font-size: 14px;

            .whoClass {
                color: #0d96ff;
            }

            i.inputicon {
                display: inline-block;
                margin-left: 12px;
                padding: 4px 4px 4px 20px;
                background-color: #f0f0f0;
                font-style: normal;
                color: #8c8c8c;
                text-align: center;
                background-repeat: no-repeat;
                background-position: 4px center;
                background-size: 12px;
                font-size: 12px;
                border-radius: 2px;
            }

            i.text.inputicon {
                background-image: url("../assets/img/meg_wirte.png");
            }

            i.voice.inputicon {
                background-image: url("../assets/img/meg_voice.png");
            }
        }

        .meeting-chatroom-list li div {
            display: inline-block;
            padding: 10px 15px;
            line-height: 22px;
            color: #494949;
            font-size: 14px;
            background-color: #fff;
            border: 1px solid #f0f0f0;
            text-align: left;
        }

        .caseStatusBtn {
            position: absolute;
            bottom: 130px;
            left: 20px;
            height: 30px;
            width: 180px;
            border: 1px solid #0083c8;
            line-height: 30px;
            text-align: center;
            background-color: #fff;
            color: #0083c8;
            border-radius: 3px;
            cursor: pointer;
            z-index: 1;

            i {
                display: inline-block;
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background-repeat: no-repeat;
                background-position: center;
                background-size: 16px;
                vertical-align: top;
            }

            i.status {
                background-image: url("../assets/img/chosennow.png");
            }

            i.on.status {
                background-image: url("../assets/img/chosennow.png");
            }
        }

        .on.voiceBtn {
            color: #fff;
            background-color: #0083c8;
        }

        .voiceBtn {
            position: absolute;
            bottom: 130px;
            right: 20px;
            height: 30px;
            width: 180px;
            border: 1px solid #0083c8;
            line-height: 30px;
            text-align: center;
            background-color: #fff;
            color: #0083c8;
            border-radius: 3px;
            cursor: pointer;
            z-index: 1;

            i {
                display: inline-block;
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background-repeat: no-repeat;
                background-position: center;
                background-size: 16px;
                vertical-align: top;
            }

            i.status {
                background-image: url("../assets/img/voiceoff.png");
            }

            i.on.status {
                background-image: url("../assets/img/voiceon.gif");
            }
        }
    }

    .meeting-chatroom-self {
        text-align: right;
    }

    .meeting-chatroom-speaking {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100px;
        padding: 10px;
        background-color: #fff;
        border-top: 1px solid #ececec;

        .input-textarea {
            font-size: 12px;
            width: 100%;
            height: 60px;
            display: inline-block;
            padding: 5px 10px;
            border: none;
            color: #494949;
            background-color: #fff;
            resize: none;
            outline: 0;
            -webkit-appearance: none;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
            -webkit-transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
            transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
        }
    }

    .meeting-btn-send {
        display: inline-block;
        vertical-align: top;

        button {
            position: absolute;
            right: 30px;
            height: 28px;
            width: 60px;
            color: #fff;
            border: none;
            background-color: #0083c8;
            box-shadow: 0px 3px 7px 0px rgba(76, 197, 156, 0.3);
            cursor: pointer;
        }
    }

    .wodk_menu {
        padding: 10px 20px;

        .wodk_item {
            height: 40px;
            line-height: 40px;
            color: #303133;
            cursor: pointer;
            margin-bottom: 15px;
            padding-left: 15px;
            border: 1px solid #f4f4f4;
            font-size: 14px;
            font-weight: 500;
            background-color: #fff;
            -webkit-transition: border-bottom-color .3s;
            transition: border-bottom-color .3s;
            outline: 0;

            .el-collapse-item__arrow {
                line-height: 40px;
                font-weight: 600;
                float: right;
            }
        }
    }

    .curNewMessage {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background-color: 0px 3px 7px 0px rgba(76, 197, 156, 0.3);
    }
}

.el-dialog__wrapper {
    .el-dialog {
        .el-dialog__body {
            .dialog-footer {
                text-align: center;
                margin-top: 10px;
            }
        }
    }

}

.detail-record {
    .upload-demo {
        .el-upload-list__item .el-icon-close {
            display: block;
            color: #000;
        }
    }

    .btnlr-gradient {
        //color: #fff;
    }

    .el-button+.el-button {
        margin-left: 30px;
    }

    .md-head {
        height: 30px;
        margin: 26px 0 22px;
        line-height: 30px;
        text-align: right;

        >span {
            float: left;
            font-size: 14px;
            font-weight: bold;
        }

        .el-input {
            width: 150px;
        }

        .el-input--small .el-input__inner {
            height: 26px;
            line-height: 26px;
            width: 121px;
        }
    }

    .md-wrap {
        padding-bottom: 10px;

        .signstatus {
            padding: 10px 0;
            text-align: center;
            border-bottom: 1px solid #ddd;
        }
    }

    .vc {
        padding-top: 20px;
        padding-right: 20px;
    }

    i.dialog_edit_icon {
        position: absolute;
        display: inline-block;
        top: 16px;
        right: 60px;
        width: 20px;
        height: 20px;
        background: url("../assets/img/dialog_edit.png") no-repeat center;
        cursor: pointer;
    }

    .dialog-footer {
        text-align: center;
        margin-top: 10px;
    }
}

.document-sign {
    .el-dialog__body {
        height: 440px;
        padding: 30px 40px;

        .dialog-footer {
            text-align: center;
            margin-top: 10px;
        }

        .line {
            border-bottom: dashed 1px #666666;
        }

        .sign-line {
            margin-top: 26px;
        }

        .sign-top {
            display: flex;
            margin-bottom: 26px;

            img {
                width: 140px;
                height: 140px;

            }

            .hold-sign {
                width: 140px;
                height: 140px;
                display: inline-block;
                text-align: center;
                line-height: 140px;
                color: #999;
                font-size: 18px;
                background-color: #fafafa;
                box-shadow: 0px 3px 6px 0px rgba(186, 186, 186, 0.2);
            }

            .sign-discrible {
                display: inline-block;
                margin-left: 45px;

                .explain {
                    margin: 25px 25px 15px 25px;
                }

                .no-set {
                    color: #e8151f;
                    cursor: pointer;
                }

                .sort {
                    margin-top: 20px;

                    .num {
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        background-color: #0083c8;
                        border-radius: 50%;
                        text-align: center;
                        color: #fff;
                        margin-right: 11px
                    }

                    .scan {
                        color: #0083c8;
                    }
                }

                .reset {
                    margin-left: 26px;
                }
            }
        }

        .end {
            width: 210px;
            height: 40px;
            float: left;
            line-height: 40px;
            font-size: 16px;
            color: #fff;
            margin: 30px 0 0 80px;
            background-image: linear-gradient(110deg, #0083c8 0%, #0083c8 100%), linear-gradient(#0083c8, #0083c8);
            background-blend-mode: normal, normal;
            -webkit-box-shadow: 0px 3px 7px 0px rgba(76, 197, 156, 0.3);
            box-shadow: 0px 3px 7px 0px rgba(76, 197, 156, 0.3);
            border-radius: 4px;
            cursor: pointer;
            text-align: center;
        }
    }
    
}
.download{
        color:#0083c8;
        text-decoration: underline;
    }
</style>
